import React, { useState, useEffect } from 'react';
import { useHistory } from '../../context/HistoryContext';
import './MemoryWarning.css';

const MemoryWarning = () => {
  const { getHistoryInfo, performCleanup } = useHistory();
  const [showWarning, setShowWarning] = useState(false);
  const [memoryUsage, setMemoryUsage] = useState(0);

  useEffect(() => {
    const checkMemory = () => {
      const info = getHistoryInfo();
      const usage = info.memoryUsage;
      setMemoryUsage(usage);
      
      // Show warning if memory usage > 25MB (reduced to be more aggressive with large images)
      const threshold = 25 * 1024 * 1024; // 25MB
      setShowWarning(usage > threshold);
    };

    checkMemory();
    const interval = setInterval(checkMemory, 10000); // Check every 10 seconds
    
    return () => clearInterval(interval);
  }, [getHistoryInfo]);

  const handleCleanup = () => {
    performCleanup();
    setShowWarning(false);
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  if (!showWarning) return null;

  return (
    <div className="memory-warning">
      <div className="warning-content">
        <span className="warning-icon">⚠️</span>
        <div className="warning-text">
          <strong>High Memory Usage</strong>
          <p>History using {formatBytes(memoryUsage)}. Consider cleaning up.</p>
        </div>
        <div className="warning-actions">
          <button onClick={handleCleanup} className="cleanup-btn">
            Clean Up
          </button>
          <button onClick={() => setShowWarning(false)} className="dismiss-btn">
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default MemoryWarning; 